import { FC } from 'react';
import { ExternalLink, Link } from 'src/components/link';
import { Sidebar } from 'src/components/sidebar';
import {
  SidebarSection,
  SidebarSections,
} from 'src/components/sidebar-section';
import { useFeatureFlags } from 'src/hooks/use-feature-flags';
import { useMonolithCurrentUser } from 'src/hooks/use-monolith-user';
import { Settings } from 'src/pages/settings/registration/use-settings';
import { isLng } from 'src/utils/is-lng';

type Props = {
  settings: Settings;
};

export const RegistrationSettingsSidebar: FC<Props> = ({ settings }) => {
  const auth = useMonolithCurrentUser();
  const { userInvitations: userInvitations } = useFeatureFlags();
  const ssoPrefix = auth.role === 'SSO_ADMIN' ? '/storage' : '';
  return (
    <Sidebar>
      <SidebarSections>
        {auth.role === 'SSO_ADMIN' && (
          <SidebarSection title="Services">
            <ExternalLink
              href={
                isLng(auth)
                  ? `${PRISMA_CONFIG.oldFrontendUrl}/#/lng/settings/premium-services`
                  : `${PRISMA_CONFIG.oldFrontendUrl}/#/storage/settings/premium-services`
              }
              mode="sidebar"
            >
              Premium Services
            </ExternalLink>
            <ExternalLink
              href={
                isLng(auth)
                  ? `${PRISMA_CONFIG.oldFrontendUrl}/#/lng/settings/advanced`
                  : `${PRISMA_CONFIG.oldFrontendUrl}/#/storage/settings/advanced`
              }
              mode="sidebar"
            >
              Advanced Settings
            </ExternalLink>
          </SidebarSection>
        )}

        {auth.role === 'TSO_USER' && (
          <SidebarSection title="Market">
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/general`}
              mode="sidebar"
            >
              General
            </ExternalLink>
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/auctions`}
              mode="sidebar"
            >
              Auctions
            </ExternalLink>
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/secondary-market`}
              mode="sidebar"
            >
              Secondary Market
            </ExternalLink>
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/surrender`}
              mode="sidebar"
              disabled={!settings.SURRENDER}
            >
              Surrender
            </ExternalLink>
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/fcfs`}
              mode="sidebar"
              disabled={!settings.FCFS}
            >
              FCFS
            </ExternalLink>
          </SidebarSection>
        )}

        <SidebarSection title="Shippers">
          <Link to="/settings/registration" mode="sidebar">
            Registration & User Management
          </Link>
          {auth.role === 'TSO_USER' && (
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/credit-limits`}
              mode="sidebar"
              disabled={
                !settings.CREDIT_LIMIT_FCFS && !settings.CREDIT_LIMIT_SECONDARY
              }
            >
              Credit Limits
            </ExternalLink>
          )}
        </SidebarSection>

        <SidebarSection title="My Company">
          <ExternalLink
            href={`${PRISMA_CONFIG.oldFrontendUrl}/#${ssoPrefix}/settings/company-information`}
            mode="sidebar"
          >
            Company Information
          </ExternalLink>
          {!userInvitations && (
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#${ssoPrefix}/settings/user-management`}
              mode="sidebar"
            >
              User Management
            </ExternalLink>
          )}
          {auth.role === 'TSO_USER' && (
            <ExternalLink
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/settings/subscriptions`}
              mode="sidebar"
            >
              Subscriptions
            </ExternalLink>
          )}
        </SidebarSection>
      </SidebarSections>
    </Sidebar>
  );
};
